import { createContext, useContext } from 'react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

const NORMAL_STALE_TIME = 5 * 60 * 1000;

// Disable cache if env var is set (production default)
const cacheDisabled = process.env.REACT_APP_DISABLE_CACHE === 'true';

// Create a client with default cache configuration
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: cacheDisabled ? 0 : NORMAL_STALE_TIME,
      cacheTime: 10 * 60 * 1000,
      refetchOnWindowFocus: false,
      refetchOnReconnect: true,
      retry: 1,
      retryDelay: 1000,
    },
  },
});

// Context for accessing query client directly if needed
const DataCacheContext = createContext(queryClient);

export function DataCacheProvider({ children }) {
  return (
    <QueryClientProvider client={queryClient}>
      <DataCacheContext.Provider value={queryClient}>
        {children}
      </DataCacheContext.Provider>
    </QueryClientProvider>
  );
}

export function useQueryClient() {
  return useContext(DataCacheContext);
}

// Helper function to invalidate specific cache keys
export function invalidateCache(keys) {
  if (Array.isArray(keys)) {
    keys.forEach(key => queryClient.invalidateQueries({ queryKey: [key] }));
  } else {
    queryClient.invalidateQueries({ queryKey: [keys] });
  }
}

// Helper function to clear all caches
export function clearAllCaches() {
  queryClient.clear();
}

export default queryClient;
